
function IsDefaultSearchInputVisible() {
    return $(defaultSearchPanel).is(":visible");
}

function IsSimpleSearchInputVisible() {
    return $(simpleSearchPanel).is(":visible");
}

function IsExpertSearchInputVisible() {
    return $('.expert').is(":visible");
}

function ShowSimpleSearchInputs() {
    $('.SearchPanelWrapper').show();
    //$('.multiSelectOptions').width(($('.multiSelectOptions').prev().get(0).clientWidth) + 'px');

    SetSimpleSearchTextBox();
    ShowSimpleSearch();
    HideDefaultSearch();
    HideExpertSearch();
    SetHiddenState(simpleSearchId);
    return false;
}
function ShowExpertSearchInputs() {
    $('.SearchPanelWrapper').show();
    //$('.multiSelectOptions').width(($('.multiSelectOptions').prev().get(0).IniientWidth) + 'px');

    SetDefaultSearchTextboxes();
    HideSimpleSearch();
    ShowExpertSearch();
    ShowDefaultSearch();
    SetHiddenState(expertSearchId);
    return false;
}
function ShowDefaultSearchInputs() {
    $('.SearchPanelWrapper').show();
    //$('.multiSelectOptions').width(($('.multiSelectOptions').prev().get(0).clientWidth) + 'px');

    SetDefaultSearchTextboxes();
    HideExpertSearch();
    HideSimpleSearch();
    ShowDefaultSearch();
    SetHiddenState(defaultSearchId);
    return false;
}

function ToggleExpertSearch() {
    if (IsExpertSearchInputVisible()) {
        HideExpertSearch();
    }
    else {
        ShowExpertSearch();
    }
}

function ShowSimpleSearch() {
    $(simpleSearchPanel).show();
}

function HideSimpleSearch() {
    $(simpleSearchPanel).hide();
}

function ShowDefaultSearch() {
    $(defaultSearchPanel).show();
}

function HideDefaultSearch() {
    $(defaultSearchPanel).hide();
}

function ShowExpertSearch() {
    $('.expert').show();
}

function HideExpertSearch() {
    $('.expert').hide();
}

function SetAutoComplete(inputControl, dropDownControl, url) {
    var completeWidth = jQuery(inputControl).outerWidth();
    $(inputControl).autocomplete(url, {
        extraParams: {
            searchfield: function () { return $(dropDownControl).val(); }
        },
        matchContains: true,
        width: completeWidth + 'px',
        minChars: 2,
        scroll: false,
        selectFirst: false,
        highlight: function (value, term) {
            return value.replace(new RegExp("(?![^&;]+;)(?!<[^<>]*)(" + term.replace(/([\^\$\(\)\[\]\{\}\*\.\+\?\|\\])/gi, "\\$1") + ")(?![^<>]*>)(?![^&;]+;)", "gi"), '<span class="ac_match">$1</span>');
        }
    });
}

function InitFieldStateToOperator($control, $operatorControl, $textField, fields, enable) {
    $control.on('change', (function() {
        var currentField = $(this).val();
        $(" option[value='" + (currentField === 3 ? 7 : 8) + "']", $operatorControl).attr("selected", "selected");
        SetFieldStateToOperator(currentField, $operatorControl, fields, enable);
        $textField.focus();
    }));

    var curval = $control.val();
    SetFieldStateToOperator(curval, $operatorControl, fields, enable);
}

function SetFieldStateToOperator(currentField, $operatorControl, fields, enable) {
    $("option", $operatorControl).removeAttr('disabled');
    $.each(fields, function (index, field) {
        if (currentField === field)
            SetContainsOperatorEnabled($operatorControl, enable);
    });
}

function SetContainsOperatorEnabled($operatorControl, enabled) {
    SetOperatorValueEnabled($operatorControl, 8, enabled);
}

function SetOperatorValueEnabled($operatorControl, value, enabled) {
    var $targetOption = $(" option[value='" + value + "']", $operatorControl);
    
    if (!enabled) {
        $targetOption.attr("disabled", "disabled");
        if ($targetOption.is(':selected')) {
            $(" option[value='7']", $operatorControl).attr("selected", "selected");
        }
    }
    else {
        $targetOption.removeAttr('disabled');
    }
}